import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('campaign-contents', options)



// WEBPACK FOOTER //
// ./src/store/modules/campaign-contents.store.js